import { useLocalState } from '@consigli/hooks';

/** Namespaced like `project-list.view`. */
export const AGENTS_INTRO_STORAGE_KEY = 'agents-directory.intro-dismissed';

/**
 * Whether the "Introducing Agents" card is still owed to this user.
 *
 * Persisted rather than held in state because the requirement is once ever, not
 * once per session: the card introduces the directory, and someone who has read
 * it and navigated away should not meet it again on their next visit. Stored
 * locally rather than on the user record — nothing else about this page is, and
 * a first-run flag is worth no round trip.
 *
 * Dismissal is one-way, so there is no setter for the open state: the X, Escape
 * and Get Started all mean the same thing, and the dialog owns which of them
 * happened.
 */
export const useAgentsIntro = (): { isOpen: boolean; dismiss: () => void } => {
  const [stored, setStored] = useLocalState<boolean>(AGENTS_INTRO_STORAGE_KEY, false);

  return {
    // useLocalState JSON.parses storage and hands it back unchecked, so only a
    // literal `true` counts as dismissed. Anything else — a hand-edited key, a
    // value some future version of this flag wrote — shows the card, which is
    // the harmless way to be wrong.
    isOpen: stored !== true,
    // Never the updater form: useLocalState types it as returning void, so the
    // stored value would come back undefined.
    dismiss: () => setStored(true),
  };
};
